import { SxProps, Theme } from '@mui/material';

export const stylesCreateNewRequestFormGridContainer: SxProps<Theme> = {
  height: '100%',
};

export const stylesCreateNewRequestGridItem: SxProps<Theme> = {
  height: '100%',
};

export const stylesCreateNewRequestCard: SxProps<Theme> = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

export const stylesCreateNewRequestCardSubheader: SxProps<Theme> = {
  fontWeight: 'fontWeightRegular',
  mt: 2,
};

export const stylesCreateNewRequestCardContent: SxProps<Theme> = {
  flex: 1,
  overflow: 'auto',
};

export const stylesCreateNewRequestFormSubtitle: SxProps<Theme> = {
  fontWeight: 'fontWeightRegular',
  color: 'primary.main',
  pb: 2,
};

export const stylesAutoCompleteSingleSelect = {
  '&.MuiAutocomplete-root .MuiAutocomplete-inputRoot': {
    padding: '0px !important',
  },
};
